import React from 'react';
import { PhoneCall } from 'lucide-react';
import { FEATURES } from '../../config/features';

/**
 * A/B arm "card_button" — rendered inside each route result card, next to Book.
 * stopPropagation so clicking it doesn't expand / select the card.
 */
const CardContactButton = ({ onClick, className = '' }) => {
    if (!FEATURES.ENABLE_CONTACT_FORM) return null;
    return (
    <button
        type="button"
        onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onClick?.();
        }}
        title="Not getting confirmed tickets? Contact us"
        className={`inline-flex items-center justify-center gap-1.5 min-h-[40px] px-3.5 rounded-xl
                    border border-orange-300 bg-white text-orange-600 hover:bg-orange-50 active:bg-orange-100
                    text-sm font-semibold whitespace-nowrap transition-colors
                    focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400 focus-visible:ring-offset-1
                    ${className}`}
    >
        <PhoneCall size={14} aria-hidden="true" />
        Contact us
    </button>
    );
};

export default CardContactButton;
